import {FC, useRef} from 'react'
import {Link} from 'react-router-dom'
import clsx from 'clsx'
import {useLayout} from '../../core'
import {KTSVG, toAbsoluteUrl} from '../../../helpers'
import {AsideMenu} from './AsideMenu'

const AsideDefault: FC = () => {
  const {config, classes} = useLayout()
  const asideRef = useRef<HTMLDivElement | null>(null)
  const {aside} = config

  const minimize = () => {
    asideRef.current?.classList.add('animating')
    setTimeout(() => {
      asideRef.current?.classList.remove('animating')
    }, 300)
  }

  return (
    <div
      id='kt_aside'
      className={clsx('aside', classes.aside.join(' '))}
      data-kt-drawer='true'
      data-kt-drawer-name='aside'
      data-kt-drawer-activate='{default: true, lg: false}'
      data-kt-drawer-overlay='true'
      data-kt-drawer-width="{default:'90px'}"
      data-kt-drawer-direction='start'
      data-kt-drawer-toggle='#kt_aside_mobile_toggle'
      ref={asideRef}
    >
      <div className='aside-inner'>
        {/* begin::Brand */}
        <div className='aside-logo flex-column-auto' id='kt_aside_logo'>
          {/* begin::Logo */}
          {aside.theme === 'dark' && (
            <Link to='/'>
              <img alt='Logo' className='h-60px h-lg-80px logo' src={toAbsoluteUrl('/media/logos/logo_reversed.svg')} />
            </Link>
          )}
          {aside.theme === 'light' && (
            <Link to='/'>
              <img alt='Logo' className='h-60px h-lg-80px logo' src={toAbsoluteUrl('/media/logos/logo_reversed.svg')} />
            </Link>
          )}
          {/* end::Logo */}
        </div>
        {/* end::Brand */}

        {/* begin::Aside menu */}
        <div className='aside-menu flex-column-fluid flex-grow-1'>
          <AsideMenu asideMenuCSSClasses={classes.asideMenu} />
        </div>
        {/* end::Aside menu */}

        {/* begin::Footer */}
        {/* <div className='aside-footer flex-column-auto pt-5 pb-7 px-5' id='kt_aside_footer'></div> */}
        {/* end::Footer */}
      </div>
    </div>
  )
}

export {AsideDefault}
